function About () {
    return (
        <article>
            <div className="large-card">
                <h3>About</h3>
                <div className="separator"></div>
                <div className="about">
                    <div className="about-left">
                        <div>
                            <h4>A true passion for the visual arts</h4>
                            <p>
                                Designing has been my main focus for the past decade, from self-learning to certifications, while going through art school and having field experience with real projects, my promise is to use those precious knowledges to help you reach your goal : gain visibility, help your business grow, give you the perfect visual signature or the best artwork you could think of.
                            </p>
                        </div>
                        <div>
                            <h4>Mastering the right tools</h4>
                            <p>
                                One thing for sure : I know my way around my softwares. Relying mainly on the Adobe Suite, I will use the right tools to make the right design : the one you need.
                            </p>
                            <p>
                                As for web, I decided to go for React.JS, a modern JavaScript framework that allows the creation of Single Page Applications : a powerful way to enhance your website and its user experience.
                            </p>
                        </div>
                        <div>
                            <h4>Communication</h4>
                            <p>
                                It is a center point in my way of working : I am here to listen to your request, talk with you about possible solutions, analyzing your needs and thinking about a full visual strategy.
                            </p>
                            <p>
                                Thinking about the long run is key to your success, and my goal is to work with you towards it.
                            </p>
                        </div>
                    </div>
                    <div className="separator-vertical"></div>
                    <div className="about-right">
                        <div>
                            <h5>10+</h5>
                            <p>
                                Years of experience
                            </p>
                        </div>
                        <div>
                            <h5>Certified</h5>
                            <p>
                                In webdesign and graphic design
                            </p>
                        </div>
                        <div>
                            <h5>Multiple domains</h5>
                            <p>
                                Graphic design, motion design, web design
                            </p>
                        </div>
                        <div>
                            <h5>Smart - Belgium</h5>
                            <p>
                                More infos about Smart Belgium
                                <a className="contact-button" href="https://guide.smart.coop/docs/conditions-générales-de-paiements?highlight=conditions">More Infos</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    )
}

export default About;